import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  selectOption: css`
    position: relative;

    &::after {
      background-color: ${hex2rgba(cssTheme.default.day.everBlack.hex, 0.2)};
      display: block;
      content: '';
      block-size: 1px;
      inset-block-end: 0;
      inset-inline: ${spacing(-2)};
      position: absolute;
      z-index: 100;
    }
  `,
  label: css`
    display: inline-block;
    margin-inline-end: ${spacing(2)};
    max-inline-size: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  name: css`
    display: block;
    inline-size: 100%;
    overflow: hidden;
    padding-inline-end: ${spacing(3.5)};
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  pointIcon: css`
    padding-inline-end: ${spacing(1)};
    padding-block: ${spacing(2)};
  `,
  select: css`
    & input[type='text'] {
      padding-inline-end: ${spacing(7)};
      text-overflow: ellipsis;
    }
  `,
  mobile: css`
    & input[type='text'] {
      padding-inline-end: 0;
    }
  `,
  button: css`
    margin-inline-end: ${spacing(7)};
  `,
}
